import React, { Component } from "react";
import { Divider, Typography } from "@material-ui/core";
import { withRouter, Redirect, Link } from 'react-router-dom';
import { connect } from "react-redux";
import { LoadingCard, SaspButton, CopyrightWidget } from "../components";

import { getQuizzesListAllResults, trackPage } from "../actions";
import { deviceData, getThisYear } from "../common";

class QuizListAllScreen extends Component {
    state = {
        show: false,
        loadingtext: ["Loading Quizzes"],
        quizList: [],
        rendered: false
    }

    componentDidMount = async () => {
        console.log(`QuizListAllScreen props: `, this.props)
        const { mcid, key } = this.props.auth_feedback;
        let data = { mcid, key }
        let tracking = deviceData(this.props.location, 'navigate');

        tracking.action = 'navigate';
        tracking.detail = 'Quiz List All Screen';

        let tobj = {
            mcid: mcid,
            key: key,
            tracking: tracking
        }

        await this.props.trackPage(tracking);
        return this.props.getQuizzesListAllResults(data, tracking);

        if (
            typeof this.props.quizListAll === 'undefined' || 
            this.props.quizListAll === null ||
            !Array.isArray(this.props.quizListAll) ||
            (Array.isArray(this.props.quizListAll) === true && this.props.quizListAll.length === 0)
        ) {
            await this.props.getQuizzesListAllResults(data, tracking);
            return null;
        } else {
            // await this.props.getQuizzesListAllResults(data, tracking);
            return this.setState({ ...this.state, quizList: this.props.quizListAll});
        }

        return this.props.getQuizzesListAllResults(data, tracking);

    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.quizListAll !== this.props.quizListAll) {
            return this.setState({ ...this.state, quizList: this.props.quizListAll, rendered: true })
        }

        if (prevProps.quizListAll === this.props.quizListAll && !this.state.rendered) {
            return this.setState({ ...this.state, quizList: this.props.quizListAll, rendered: true })
        }

        if (prevState.quizList !== this.state.quizList) {
            console.log(`QuizListAllScreen quizList updated: `, this.state.quizList);
            return this.setState({ ...this.state, show: true });
        }
    }  
    
    componentWillUnmount = async () => {
        return this.setState({ ...this.state, show: false, quizList: [], rendered: false })
    }

    render() {
        try {
            if (!this.state.show) {
                return (
                    <LoadingCard textarray={this.state.loadingtext} /> 
                )
            } else {
                console.log(`QuizListAllScreen quizList: `, this.state.quizList)
                return (
                    <div className=" aua-overflow" id="QuestionDiv">
                        <Typography className="homeDividerText">My Quiz Results</Typography>
                        <Divider className="margin-bottom-16" />

                        <div className="margin-bottom-16 width100 var-row-col">
                            {this.state.quizList.map((quiz, index) => {
                                const reviewObj = {
                                    pathname: '/quizListScreen',
                                    deckid: quiz.deckid,
                                    deckID: quiz.deckid,
                                    gamemode: quiz.gamemode,
                                    gameMode: quiz.gamemode
                                }

                                const retakeObj = {
                                    pathname: '/quizScreen',
                                    deckid: quiz.deckid,
                                    deckID: quiz.deckid,
                                    gamemode: quiz.gamemode,
                                    gameMode: quiz.gamemode
                                }

                                return (
                                    <div key={`review-${quiz.deckid}-${index}`} className="margin-bottom-16 review-quiz-card">
                                        
                                        <div style={{"minHeight": "56px", "borderBottom": "1px solid var(--aua-dark-blue)"}} className="text-blue margin-bottom-4 margin-top-4 width100 text-strong">
                                            {quiz.title}<br/>
                                            <small className="text-muted text-small">{quiz.subtitle}</small>
                                        </div>

                                        <div className="flex-row-start">
                                            <div className="width100">
                                                <dl>
                                                    <dt className="text-strong margin-bottom-4">Last Taken on:</dt>
                                                    <dd className="margin-bottom-4">{quiz.completedON}</dd>
                                                    <dt className="text-strong margin-bottom-4">You have taken:</dt>
                                                    <dd className="margin-bottom-4"><strong className="text-blue">{quiz.quizzes}</strong> quizzes</dd>
                                                    <dt className="text-strong margin-bottom-4">You have answered:</dt>
                                                    <dd className="margin-bottom-4"><strong className="text-green">{quiz.correct}</strong> questions correctly</dd>
                                                    <dd className="margin-bottom-4">out of <strong className="text-blue">{quiz.total}</strong> questions</dd>
                                                    <dt className="text-strong margin-bottom-4">Your overall score:</dt>
                                                    <dd className="margin-bottom-4"><strong className="text-blue">{quiz.percentage}%</strong></dd>
                                                </dl>
                                            </div>
                                        </div>

                                        <Divider className="margin-bottom-16" />

                                        <div className="flex-row-between margin-bottom-16 width100">
                                            <SaspButton className="aua-btn btn-dark-blue">
                                                <Link to={retakeObj} >
                                                    Take Quiz
                                                </Link>
                                            </SaspButton>

                                            <SaspButton className="aua-btn btn-blue">
                                                <Link to={reviewObj} >
                                                    Review Topic
                                                </Link>
                                            </SaspButton>
                                        </div>
                                    </div> 
                                )
                            })}
                        </div>
                        
                        <Divider className="margin-bottom-16" />

                        <CopyrightWidget 
                            style={{width: "auto;"}}
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-8 padding-top-8 padding-bottom-24"
                        />
                    </div>
                )
            }
        } catch (error) {
            console.log(`QuizListAllScreen render error: `, error)
            return (
                <Redirect to="/home" />
            )
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback } = state.auth;
    const { quizListAll } = state.decks;

    return {
        auth_feedback,
        quizListAll
    }
}

export default connect(
    mapStateToProps, 
    { getQuizzesListAllResults, trackPage }
)(QuizListAllScreen);